import React from 'react';
import * as Styled from './LoopNotification.styled';
/**
 * Renders a Notification that shows available Loop Credit when user
 * clicks on Shop Now at the final step of the Loop flow
 */
var LoopNotification = function (_a) {
    var loopCredit = _a.loopCredit, returnURL = _a.returnURL;
    var formattedLoopCredit = (loopCredit / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    return (React.createElement(Styled.LoopNotification, null,
        React.createElement(Styled.NotificationContainer, null,
            React.createElement(Styled.Title, null,
                React.createElement(Styled.LoopCredit, null, formattedLoopCredit),
                " Applied at Checkout"),
            React.createElement(Styled.LinkText, { underline: true, size: "Mini", href: "https://".concat(returnURL) }, "Back to Returns"))));
};
export default LoopNotification;
